import React from 'react';

const DownloadCSV = ({ data, fileName }) => {
  const convertToCSV = (objArray) => {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;

    // Add CSV headers from the keys of the first object in the array
    const headers = Object.keys(array[0]);
    let str = headers.join(',') + '\r\n'; // Add headers row

    // Add data rows
    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in array[i]) {
        if (line !== '') line += ',';

        // Check if value is null or undefined, then put empty string, otherwise the value itself
        const value = array[i][index] !== null && array[i][index] !== undefined 
                      ? array[i][index] 
                      : ''; // Put empty string if null/undefined
        // Handle commas inside data, if any, by wrapping them in quotes
        line += `"${value}"`;
      }
      str += line + '\r\n';
    }
    return str;
  };

  const downloadCSV = () => {
    const csvData = new Blob([convertToCSV(data)], { type: 'text/csv' });
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.href = csvURL;
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button onClick={downloadCSV}>Download</button>
  );
};

export default DownloadCSV;



// WEBPACK FOOTER //
// ./src/utils/DownloadCSV.js